import * as dateFnsCompat from 'utils/date-fns-compat';

import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import { OverlayTrigger, Popover, Thumbnail } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import { withProps } from 'recompose';
import 'slick-carousel/slick/slick.css';
import { contentStatus, dateFormats, routes, userEventCompletionStatus } from '../../../../constants';
import { tileCpdCategoryClassName } from '../../../../services';
import { pluralise } from '../../../../utils';
import { Icon } from '../../../components';
import { TooltipWrapper } from './tooltip-wrapper';

const overlay = (status, completionStatus) =>
  <Popover id='course-status-popover'>
    <p>
      {
        completionStatus === userEventCompletionStatus.Completed ?
          status === contentStatus.Archived.value ?
            'You completed this course but it has been archived. You still get the points, but it can no longer be viewed.' :
            'You completed this course but it is no longer available to view. Come back later to view this item or contact Caddie for more information.'
          :
          status === contentStatus.Archived.value ?
            'This course has been archived and is no longer available.' :
            'This course is not available to view. Come back later to view this item or contact Caddie for more information.'
      }
    </p>
  </Popover>

const CourseTile = ({
  altText,
  fullCpdCategory,
  category,
  publisher,
  cpdPoints,
  date,
  duration,
  image,
  imageSet,
  title,
  venue,
  suburb,
  eventRoute,
  price,
  isTasaCpd,
  toggleHandler,
  selected,
  completionStatus,
  status
}) => (
    <div className={'tile' + (selected ? " selected" : " unselected")} onClick={toggleHandler}>
      <header>
        <div className='title-header'>
          {
            completionStatus === userEventCompletionStatus.Registered ?
              <div className="cpd-progress-banner registered">Registered</div> : null
          }
          {
            completionStatus === userEventCompletionStatus.Completed ?
              <div className="cpd-progress-banner completed">Completed</div> : null
          }
          {
            completionStatus === userEventCompletionStatus.Failed ?
              <div className="cpd-progress-banner failed">Not Attending</div> : null
          }
          {
            status !== contentStatus.Published.value && completionStatus === userEventCompletionStatus.Unknown ?
              <div className="cpd-progress-banner archived">
                {status === contentStatus.Archived.value ? "Archived" : "Unavailable"}
              </div> : null
          }
          {
            selected && toggleHandler ?
              <div onClick={toggleHandler} className='task-remove-banner'>
                Selected<Icon className='right' iconSize={2} icon='close-thick' />
              </div> : null
          }
          {
            toggleHandler ?
              <Thumbnail src={image} srcSet={imageSet} alt={altText} /> :
              status === contentStatus.Published.value || completionStatus !== userEventCompletionStatus.Unknown ?
                <LinkContainer to={eventRoute}>
                  <Thumbnail src={image} srcSet={imageSet} alt={altText} />
                </LinkContainer> :
                <OverlayTrigger placement='top' overlay={overlay(status, completionStatus)}>
                  <Thumbnail src={image} srcSet={imageSet} alt={altText} />
                </OverlayTrigger>
          }
        </div>
      </header>
      <main>
        <div className='category'>
          {category ? (
            <TooltipWrapper
              className={
                isTasaCpd ? 'fixed-cat' : tileCpdCategoryClassName(category)
              }
              category={category}
              fullCpdCategory={fullCpdCategory}
            />
          ) : (
            <span className='publisher'>{publisher}</span>
          )}
          {
            isTasaCpd ?
              <span className='cat'>TPB</span> : null
          }
          <Icon className='icon' icon="education" iconSet='glyphicon' />
        </div>
        {category ? <div className='publisher'>{publisher}</div> : null}
        <div className='title'>
          {
            toggleHandler ?
              <p>{title}</p> :
              status === contentStatus.Published.value || completionStatus !== userEventCompletionStatus.Unknown ?
                <Link to={eventRoute}>{title}</Link> :
                <OverlayTrigger placement='bottom' overlay={overlay(status, completionStatus)}>
                  <p>{title}</p>
                </OverlayTrigger>
          }
        </div>
        <span className='date-time'>
          {date && dateFnsCompat.format(date, dateFnsCompat.getMinutes(date) === 0 ? dateFormats.Short12hourClockDateHour : dateFormats.Short12hourClockDateTime)}
        </span>
      </main>
      <footer>
        <span className='time'>{duration}</span>
        {cpdPoints ? <span className='points'>{`${cpdPoints} CPD ${pluralise('hour', cpdPoints)}`}</span> : null}
        {suburb ? <span className='venue'>{suburb}</span> : null}
        {price > 0 ? <span className='price'>Fr. ${price}</span> : <span className='price'>FREE</span>}
      </footer>
    </div>
  );

CourseTile.propTypes = {
  altText: PropTypes.string,
  category: PropTypes.string,
  duration: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  id: PropTypes.number,
  taskId: PropTypes.number,
  isTasaCpd: PropTypes.bool
};

export default withProps(({ id, externalCpdRecordsForUser, completionStatus, taskId }) => ({
  eventRoute: {
    pathname: routes.app.training.event, search: `?${queryString.stringify({ eventId: id, taskId })}`
  }
}))(CourseTile);


// WEBPACK FOOTER //
// ./src/containers/pages/app/partials/course-tile.js